export default {
    namespaced: true,
    state: {
        sizeLimit: 5,      // MB
        countLimit: 1,
        files: null,
        multiple: false,
        isSubmitted: false,
    },
    getters: {
        getFiles: (state) => state.files,
        getSizeLimit: (state) => state.sizeLimit,
        getCountLimit: (state) => state.countLimit,
        getMultiple: (state) => state.multiple,
        getIsSubmitted: (state) => state.isSubmitted,
    },
    mutations: {
        SET_FILES(state, payload) {
            state.files = payload
        },
        SET_SIZE_LIMIT(state, payload) {
            state.sizeLimit = payload
        },
        SET_COUNT_LIMIT(state, payload) {
            state.countLimit = payload
        },
        SET_MULTIPLE(state, payload) {
            state.multiple = payload
        },
        SET_SUBMITTED(state, payload) {
            state.isSubmitted = payload
        },
    },
    actions: {}
}
